export const JIRA_PRODUCT_ID = 'jira';
export const NAVIGATION_V3_EXPERIENCE = 'jira.nav-v3';
export const FILTER_LIST_LIMIT = 10;
export const ISSUE_LIST_LIMIT = 10;
export const OTHERS_LIST_LIMIT_NO_ADVANCED_ROADMAPS_ACCESS = 6;
export const OTHERS_LIST_LIMIT_ADVANCED_ROADMAPS_ACCESS = 8;
export const DEFAULT_COLLAB_GRAPH_URL = 'gateway/api/collaboration';
export const DEFAULT_ISSUE_LABELS_SERVICE_URL = '/rest/api/1.0/labels/suggest';
export const ISSUE_NAVIGATOR_URL = `/issues/?jql=${encodeURIComponent('created >= -30d order by created DESC')}`;
export let JiraScope = /*#__PURE__*/function (JiraScope) {
  JiraScope["Issue"] = "jira.issue";
  JiraScope["ProjectFilter"] = "jira.project,filter";
  JiraScope["BoardProjectFilter"] = "jira.board,project,filter";
  JiraScope["BoardProjectFilterPlans"] = "jira.board,project,filter,plan";
  JiraScope["Project"] = "jira.project";
  JiraScope["Assignee"] = "urs.user-jira";
  return JiraScope;
}({});
export let JiraFilters = /*#__PURE__*/function (JiraFilters) {
  JiraFilters["Projects"] = "projects";
  JiraFilters["Assignees"] = "assignees";
  JiraFilters["Status"] = "binary_status_categories";
  JiraFilters["Date"] = "lastModified";
  JiraFilters["ReportedBy"] = "reportedBy";
  JiraFilters["IssueLabels"] = "issueLabels";
  return JiraFilters;
}({});